import Components from "../../components";
import { useNavigate } from "react-router-dom";
import settings from "./settings";

const Addresses = ({ data, dataSetter }) => {
  const navigate = useNavigate();
  const onBackClick = () => {
    navigate("/account");
  };
  return (
    <div>
      <Components.PageHeader
        id="page-header"
        label="Page Header"
        title="Adreslerim"
        onBackClick={onBackClick}
        extendedSettings={settings}
        safeArea={data?.system?.safeArea}
        pixelRatio={data?.system?.pixelRatio}
      />
      <Components.Addresses
        id="addresses"
        label="Addresses"
        extendedSettings={settings}
        data={data}
        dataSetter={dataSetter}
      />
    </div>
  );
};

export default Addresses;
